<app-header [pageName]="pageName" [viewSignUp]="displayReg" [viewSignIn]="displayLogin"
    (closeAuthForms)="closeForms($event)"></app-header>

<div class="page-header header-color">



    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <p style="color: #fff;"><a class="breadcrumbs" href="/home">Home</a> / <a class="breadcrumbs">view</a>
                </p>
            </div>
        </div>

        <mat-tab-group animationDuration="500ms">

            <mat-tab label="Details">

                <div class="row m-t-2">
                    <div class="col-md-12">
                        <div class="alert alert-success" role="alert" *ngIf="successMessage">
                            {{successMessage}}
                        </div>
                    </div>

                    <div class="col">
                        <h1>{{property._source.name}}</h1>
                    </div>

                    <!-- <div class="col-md-auto">
                        <input (click)="onEvaluate(property)" class="btn btn-eval rounded-pill" type="button"
                            value="REQUEST EVALUATION">
                        <div class="col-md-12 text-center" *ngIf="isLoading">
                            <img class="loader" src="../../../assets/images/loader.gif" width="60px" alt="">
                        </div>
                    </div> -->


                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="valuation-heading">
                            <span class="inner-heading">Property Details</span>
                        </div>
                        <div class="row w-100">
                            <div class="col-md-6 text-center">
                                <div class="card border-success mx-sm-1 m-t-2">
                                    <div class="card border-success shadow text-success p-3 my-card"><span
                                            class="fa fa-users" aria-hidden="true"></span></div>
                                    <div class="text-success text-center m-t-2">
                                        <p class="nogutters">Attendance</p>
                                    </div>
                                    <div class="text-success text-center">
                                        <h4 class="nogutters">{{property._source.onSiteAttendance}}</h4>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 text-center">
                                <div class="card border-success mx-sm-1 m-t-2">
                                    <div class="card border-success shadow text-success p-3 my-card">
                                        <span class="fa fa-map-pin" aria-hidden="true"></span>
                                    </div>
                                    <div class="text-success text-center m-t-2">
                                        <p class="nogutters">EventSite</p>
                                    </div>
                                    <div class="text-success text-center">
                                        <h4 class="nogutters">{{property._source.eventSite}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table class="table table-striped m-t-1">
                            <tbody>
                                <tr>
                                    <th>
                                        Category: {{property._source.category}}
                                    </th>
                                </tr>
                                <tr>
                                    <th>
                                        Creation Date: {{property._source.creationDate | date}}
                                    </th>
                                </tr>
                                <tr>
                                    <th>
                                        Industry: {{property._source.industry}}
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                        
                        

                    </div>

                    <div class="col">
                        <div class="valuation-heading">
                            <div class="row">
                                <div class="col">
                                    <span class="inner-heading">Description</span>
                                </div>
                                <!-- <div class="col-md-auto">
                                    <input class="btn btn-eval rounded-pill" type="button" value="REQUEST EVALUATION">
                                </div> -->
                            </div>
                        </div>
                        <p>{{property._source.description}}</p>
                    </div>
                </div>


                <div class="row">
                    <div class="col-md-12">
                        <div class="valuation-heading">
                            <span class="inner-heading">Property Type(s)</span>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="alert alert-success" role="alert">
                            {{property._source.type}}
                        </div>
                    </div>

                </div>

            </mat-tab>

            <mat-tab label="Reviews">
                <div class="row m-t-2">
                    <div class="col">
                        No reviews available
                    </div>
                </div>
            </mat-tab>

        </mat-tab-group>







    </div>
</div>